module.exports = __webpack_public_path__ + "img/03.4a0eec83.png";